import { jsx as _jsx } from "react/jsx-runtime";
import { EOrderDirection } from '#models/table';
import { TableCell, TableSortLabel } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
export const SwyftTableHeader = ({ 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
children }) => _jsx("div", {});
const mapOrderDirection = {
    [EOrderDirection.Ascending]: 'asc',
    [EOrderDirection.Descending]: 'desc'
};
export const SwyftTableInnerHeader = ({ col, sortField, sortDirection, onSortChange, width, align }) => (_jsx(TableCell, { width: width, align: align, children: !col.sortable ? (!col.templateHeader ? (col.header) : (col.templateHeader)) : (_jsx(TableSortLabel, { active: sortField === col.name, hideSortIcon: false, direction: (sortField === col.name
            ? mapOrderDirection[sortDirection] || EOrderDirection.Descending
            : EOrderDirection.Descending), onClick: () => onSortChange(col.name), IconComponent: ExpandMore, children: !col.templateHeader ? col.header : col.templateHeader })) }, col.name));
